* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 2px;
}

.action-buttons {
  display: flex;
  justify-content: space-between;
}
